import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { NgForm } from '@angular/forms';
import { UtilService } from '../service/util.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../service/api.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';
import { MessageConstants } from '../constants/message-constants';
import { EmailMaskPipe } from '../pipe/emailMask.pipe';

@Component({
  selector: 'app-reset-pwd-link',
  templateUrl: './reset-pwd-link.component.html',
  styleUrls: ['./reset-pwd-link.component.scss']
})
export class ResetPwdLinkComponent implements OnInit {

  email = null;
  @ViewChild('resetPasswordForm', { static: true }) public resetPasswordForm: NgForm;
  @ViewChild('resendCodeForm', { static: true }) public resendCodeForm: NgForm;
  resendCodeModal = null;
  resetPasswordModal = null;
  passwordRule = Constants.PASSWORD_RULE;
  passwordFormatError = Constants.PASSWORD_FORMAT_ERROR;
  urlParamMissingMsg = Constants.PASSWORD_RESET_LINK_PARAM_MISSING_ERROR;
  confirmationCodeMessage: any = null;
  isMalformedEmail = true;

  constructor(private route: ActivatedRoute, private apiService: ApiService, public authService: AuthenticationService, private router: Router, private utilService: UtilService, private toast: ToastService, private emailMaskPipe: EmailMaskPipe) {

  }

  ngOnInit() {
    this.isMalformedEmail = true;
    this.init();
    this.initResetPasswordModal();
    this.initResendCodeModal();
  }

  init() {
    this.route.queryParamMap.subscribe(queryParams => {
      var token = queryParams.get("token");
      this.parseToken(token);
    });
  }

  parseToken(token) {
    var params = {};
    if (token) {
      var decodedToken = atob(token);
      if (decodedToken) {
        var pair = decodedToken.split('=');
        if (pair.length == 2) {
          params[pair[0]] = pair[1];
        }
        let regex = new RegExp(Constants.VALIDATE_EMAIL_REGEX);
        if (params && params.hasOwnProperty('email') && params['email'] && regex.test(params['email'])) {
          this.isMalformedEmail = false;
          this.email = params['email'];
          this.confirmationCodeMessage = MessageConstants.CONFRIMATION_CODE_MESSAGE.replace("maskedEmail", this.emailMaskPipe.transform(this.email));
        } else {
          this.isMalformedEmail = true;
        }
      } else {
        this.isMalformedEmail = true;
      }
    }
  }

  initResetPasswordModal() {
    this.resetPasswordModal = null;
    this.resetPasswordModal = {
      code: null,
      username: this.email,
      password: null,
      confirmPassword: null
    }
  }

  formSubmit(form: NgForm) {
    this.resetPasswordForm = form;
    if (this.resetPasswordForm.valid) {
      // console.log("form submit model is::", this.resetPasswordModal);

      if (this.resetPasswordModal.password != this.resetPasswordModal.confirmPassword) {
        this.toast.showError("New password and confirm password do not match.");
        return;
      }
      this.utilService.showSpinner();
      this.authService.confirmForgotPassword(this.resetPasswordModal).then((data) => {
        this.utilService.hideSpinner();
        this.toast.showSuccess("Password updated successfully");
        this.resetForm();
        setTimeout(() => {
          this.router.navigate(["/"]);
        }, 2000);
      }).catch((error) => {
        this.utilService.hideSpinner();
        if (error.error.status == Constants.HTTP_NOT_FOUND) {
          this.toast.showError(MessageConstants.UPDATE_PASSWORD_404_ERROR);
        } else if (["Attempt limit exceeded, please try after some time."].includes(error.error.message)) {
          this.toast.showError(MessageConstants.UPDATE_PASSWORD_MAX_LIMIT);
        } else {
          this.toast.showError(error.error.message);
        }
      });
    }
  }

  resetForm() {
    if (this.resetPasswordForm) {
      this.resetPasswordForm.reset();
      this.resetPasswordForm.resetForm();
    }
    this.initResetPasswordModal();
  }

  naviagteToLogin() {
    this.resetForm();
    this.router.navigate(["/"]);
  }

  // resendConfirmationCode() {

  //   var paylaod = {
  //     "username": this.resetPasswordModal.username
  //   };

  //   console.log("Resend code : ", paylaod);
  //   this.getConfirmationCode(paylaod);
  // }

  // getConfirmationCode(payload) {
  //   this.utilService.showSpinner();
  //   this.authService.forgotPassword(payload).then((data) => {
  //     this.utilService.hideSpinner();
  //     this.toast.showSuccess(data['message']);
  //   }).catch((error) => {
  //     this.utilService.hideSpinner();
  //     this.toast.showError(error.error.message);
  //   });
  // }

  initResendCodeModal() {
    console.log("init resend modal : ", this.email);
    this.resendCodeModal = null;
    this.resendCodeModal = {
      username: this.email
    }
    console.log("resendCodeModal :: ", this.resendCodeModal);
  }

  resendConfirmationCode() {
    // var paylaod = {
    //   "username": this.resetPasswordModal.username
    // };

    // console.log("Resend code : ", paylaod);
    // this.getConfirmationCode(paylaod);
  }

  getConfirmationCode(form: NgForm) {
    this.resendCodeForm = form;
    console.log("Resend code form submit : ", this.resendCodeModal);
    if (this.resendCodeForm.valid) {
      this.utilService.showSpinner();
      this.authService.forgotPassword(this.resendCodeModal).then((data) => {
        this.toast.showSuccess(data['message']);
        setTimeout(() => {
          this.utilService.hideSpinner();
          document.getElementById("closeResendCode").click();
          this.isMalformedEmail = true;
          this.router.navigate(["/"]);
        }, 1000);
      }).catch((error) => {
        this.utilService.hideSpinner();
        this.toast.showError(error.error.message);
      });
    }
  }

  resetResendCodeForm() {
    if (this.isMalformedEmail) {
      if (this.resendCodeForm) {
        this.resendCodeForm.reset();
        this.resendCodeForm.resetForm();
      }
      this.initResendCodeModal();
    }
  }
}
